import { render, staticRenderFns } from "./BalanceModal.vue?vue&type=template&id=df1c607e&scoped=true&"
import script from "./BalanceModal.vue?vue&type=script&lang=js&"
export * from "./BalanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1c607e",
  null
  
)

export default component.exports